import React, { FC } from 'react';
import { Global } from '@mantine/core';

const GlobalStyles: FC = () => {
  return (
    <Global
      styles={theme => ({
        'html, body': {
          height: '100%',
          overflow: 'hidden',
          background: theme.colors.gray[0],
        },
        '#root': {
          height: '100%',
          overflow: 'hidden',
        },
      })}
    />
  );
};

export { GlobalStyles };
